<!--
 * @Author: your name
 * @Date: 2021-09-20 10:09:13
 * @LastEditTime: 2021-12-26 15:51:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\views\PC\myList\myList.vue
-->
<template>
  <div class="my-list">
    <div class="create-project" @click="newProject" v-if="currNum === 0">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4V20" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M20 12H4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      {{$t('MyList.newProject')}}
    </div>
    <div class="tb-create">
      <div class="table-list">
        <div class="tb-item" v-for="(item,index) in tableListName" :key="index+ '_' +item" :class="index === currNum?'curr':''" @click="changeCurrNum(index)">{{item}}</div>
      </div>
    </div>
    <div v-if="currNum === 0" class="list-item-first">
      <div v-for="(item,index) in projectList" :key="index" class="list-item">
        <div class="top-control">
          <div class="projectType">{{item.projectType}}</div>
          <div class="svg-box">
            <svg @click="viewProject(item)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 10.5L19 5.125C19 4.84594 18.9515 4.56961 18.8573 4.3118C18.763 4.05398 18.6249 3.81972 18.4508 3.6224C18.2767 3.42507 18.07 3.26855 17.8425 3.16176C17.615 3.05497 17.3712 3 17.125 3L5.875 3C5.37772 3 4.9008 3.22389 4.54917 3.6224C4.19754 4.02092 4 4.56142 4 5.125L4 17.875C4 18.4386 4.19754 18.9791 4.54917 19.3776C4.90081 19.7761 5.37772 20 5.875 20L10 20" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 8H14" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M8 13H10" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M18 19L20 21" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
              <circle cx="15.5" cy="16.5" r="3.5" stroke="#18D6BE" stroke-width="1.5"/>
            </svg>
            <svg v-if="item.locked !== '1'" @click="editProject(item)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 10.501V19.126C18 19.3722 17.9515 19.616 17.8573 19.8435C17.763 20.071 17.6249 20.2777 17.4508 20.4518C17.2767 20.6259 17.07 20.764 16.8425 20.8582C16.615 20.9525 16.3712 21.001 16.125 21.001H4.875C4.37772 21.001 3.90081 20.8034 3.54917 20.4518C3.19754 20.1002 3 19.6232 3 19.126V7.87598C3 7.37869 3.19754 6.90178 3.54917 6.55015C3.90081 6.19852 4.37772 6.00098 4.875 6.00098H12.7256" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21.5598 2.49684C21.4913 2.42158 21.4082 2.36098 21.3157 2.31872C21.2231 2.27646 21.1229 2.2534 21.0212 2.25095C20.9194 2.2485 20.8183 2.2667 20.7237 2.30445C20.6292 2.3422 20.5434 2.39872 20.4713 2.47059L19.8915 3.04762C19.8212 3.11794 19.7817 3.21329 19.7817 3.3127C19.7817 3.41211 19.8212 3.50746 19.8915 3.57778L20.423 4.1084C20.4579 4.14341 20.4993 4.17119 20.5449 4.19014C20.5905 4.2091 20.6394 4.21885 20.6888 4.21885C20.7382 4.21885 20.7871 4.2091 20.8327 4.19014C20.8783 4.17119 20.9198 4.14341 20.9546 4.1084L21.5199 3.5459C21.8059 3.26043 21.8326 2.79543 21.5598 2.49684Z" fill="#18D6BE"/>
              <path d="M18.7191 4.22031L10.2572 12.6672C10.2059 12.7183 10.1686 12.7817 10.149 12.8514L9.75756 14.0172C9.74818 14.0488 9.74752 14.0824 9.75564 14.1144C9.76375 14.1463 9.78035 14.1755 9.80368 14.1989C9.82701 14.2222 9.85621 14.2388 9.88818 14.2469C9.92016 14.255 9.95374 14.2544 9.98537 14.245L11.1502 13.8536C11.2199 13.8339 11.2833 13.7966 11.3344 13.7453L19.7813 5.2825C19.8594 5.20352 19.9033 5.09689 19.9033 4.98578C19.9033 4.87467 19.8594 4.76805 19.7813 4.68906L19.3149 4.22031C19.2358 4.14145 19.1287 4.09717 19.017 4.09717C18.9053 4.09717 18.7982 4.14145 18.7191 4.22031Z" fill="#18D6BE"/>
            </svg>
            <svg v-if="item.locked !== '1'" @click="deleteProjectFn(item)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.25 5.25049L6.1875 20.2505C6.23203 21.1172 6.8625 21.7505 7.6875 21.7505H16.3125C17.1408 21.7505 17.7595 21.1172 17.8125 20.2505L18.75 5.25049" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3.75 5.25049H20.25" stroke="#18D6BE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M9 5.25025V3.37525C8.99957 3.22739 9.02838 3.0809 9.08476 2.94422C9.14114 2.80753 9.22399 2.68334 9.32854 2.57879C9.4331 2.47424 9.55729 2.39139 9.69397 2.335C9.83066 2.27862 9.97715 2.24982 10.125 2.25025H13.875C14.0229 2.24982 14.1693 2.27862 14.306 2.335C14.4427 2.39139 14.5669 2.47424 14.6715 2.57879C14.776 2.68334 14.8589 2.80753 14.9152 2.94422C14.9716 3.0809 15.0004 3.22739 15 3.37525V5.25025" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 8.25073V18.7507" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.625 8.25073L9 18.7507" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.375 8.25073L15 18.7507" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="bottom-con">
          <div class="top-title-box">
            <img :src="item.projectIcon" alt="img">
            <span @click="viewProject(item)">{{item.projectName}}</span>
          </div>
          <div class="bottom-desc">
            <div class="desc ellipsis" :title="item.projectDesc">{{item.projectDesc}}</div>
            <div v-if="item.createTime" class="time">{{$t('My.project.CreationTime')}}{{item.createTime.substring(0,10)}}</div>
          </div>
        </div>
      </div>
      <div v-if="!projectList.length" style="color: #bbb" class="no-data">{{$t('HotTask.NoData')}}</div>
      <!-- <div style="text-align: right;">
        <div v-if="showLoadMore1" class="load-more">Load More</div>
      </div> -->
    </div>
    <div v-else-if="currNum === 1">
      <div v-if="taskListFather" class="task-list-box">
        <div v-for="(item,index) in taskList" :key="index" class="list-item task-list">
          <div class="top-control">
              <div v-if="item.status === 'temp'" class="status-box status1">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="4" cy="4" r="4" fill="white"/>
                </svg>
                <span>{{$t('Task.taskStatus.temp')}}</span>
              </div>
              <div v-else-if="item.status === 'review'" class="status-box status2">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="4" cy="4" r="4" fill="white"/>
                </svg>
                <span>{{$t('Task.taskStatus.review')}}</span>
              </div>
              <div v-else-if="item.status === 'back'" class="status-box status3">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="4" cy="4" r="4" fill="white"/>
                </svg>
                <span>{{$t('Task.taskStatus.back')}}</span>
              </div>
              <div v-else-if="item.status === 'ongoing'" class="status-box status4">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="4" cy="4" r="4" fill="white"/>
                </svg>
                <span>{{$t('Task.taskStatus.ongoing')}}</span>
              </div>
              <div v-else-if="item.status === 'upcoming'" class="status-box status5">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="4" cy="4" r="4" fill="white"/>
                </svg>
                <span>{{$t('Task.taskStatus.upcoming')}}</span>
              </div>
              <div v-else-if="item.status === 'finished'" class="status-box status6">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="4" cy="4" r="4" fill="white"/>
                </svg>
                <span>{{$t('Task.taskStatus.finished')}}</span>
              </div>
              <div v-else-if="item.status === 'close'" class="status-box status7">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="4" cy="4" r="4" fill="white"/>
                </svg>
                <span>{{$t('Task.taskStatus.close')}}</span>
              </div>
            <div class="svg-box">
              <svg v-if="item.status === 'close' && Number(item.totalAwards) !== 0" style="cursor: pointer" @click="getBack(item)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 20.9995C7.03125 20.9995 3 16.9683 3 11.9995C3 7.03076 7.03125 2.99951 12 2.99951C16.9687 2.99951 21 7.03076 21 11.9995" stroke="#18D6BE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M12 12C10.8958 12 10 11.1042 10 10C10 8.89583 10.8958 8 12 8C13.1042 8 14 8.89583 14 10" stroke="#18D6BE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M12 12C13.1042 12 14 12.8958 14 14C14 15.1042 13.1042 16 12 16C10.8958 16 10 15.1042 10 14" stroke="#18D6BE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M17 19L19 21L21 19" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19 15V21" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="12.25" y1="7.25" x2="12.25" y2="6.75" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
                <line x1="12.25" y1="17.25" x2="12.25" y2="16.75" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <!-- <svg v-if="item.status === 'close'"  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 10.5L19 5.125C19 4.84594 18.9515 4.56961 18.8573 4.3118C18.763 4.05398 18.6249 3.81972 18.4508 3.6224C18.2767 3.42507 18.07 3.26855 17.8425 3.16176C17.615 3.05497 17.3712 3 17.125 3L5.875 3C5.37772 3 4.9008 3.22389 4.54917 3.6224C4.19754 4.02092 4 4.56142 4 5.125L4 17.875C4 18.4386 4.19754 18.9791 4.54917 19.3776C4.90081 19.7761 5.37772 20 5.875 20L10 20" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 8H14" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M8 13H10" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M18 19L20 21" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="15.5" cy="16.5" r="3.5" stroke="#18D6BE" stroke-width="1.5"/>
              </svg> -->
              <svg @click="viewTask(item)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 10.5L19 5.125C19 4.84594 18.9515 4.56961 18.8573 4.3118C18.763 4.05398 18.6249 3.81972 18.4508 3.6224C18.2767 3.42507 18.07 3.26855 17.8425 3.16176C17.615 3.05497 17.3712 3 17.125 3L5.875 3C5.37772 3 4.9008 3.22389 4.54917 3.6224C4.19754 4.02092 4 4.56142 4 5.125L4 17.875C4 18.4386 4.19754 18.9791 4.54917 19.3776C4.90081 19.7761 5.37772 20 5.875 20L10 20" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 8H14" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M8 13H10" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M18 19L20 21" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="15.5" cy="16.5" r="3.5" stroke="#18D6BE" stroke-width="1.5"/>
              </svg>
              <svg v-if="['back','temp'].includes(item.status)" @click="editTask(item)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 10.501V19.126C18 19.3722 17.9515 19.616 17.8573 19.8435C17.763 20.071 17.6249 20.2777 17.4508 20.4518C17.2767 20.6259 17.07 20.764 16.8425 20.8582C16.615 20.9525 16.3712 21.001 16.125 21.001H4.875C4.37772 21.001 3.90081 20.8034 3.54917 20.4518C3.19754 20.1002 3 19.6232 3 19.126V7.87598C3 7.37869 3.19754 6.90178 3.54917 6.55015C3.90081 6.19852 4.37772 6.00098 4.875 6.00098H12.7256" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21.5598 2.49684C21.4913 2.42158 21.4082 2.36098 21.3157 2.31872C21.2231 2.27646 21.1229 2.2534 21.0212 2.25095C20.9194 2.2485 20.8183 2.2667 20.7237 2.30445C20.6292 2.3422 20.5434 2.39872 20.4713 2.47059L19.8915 3.04762C19.8212 3.11794 19.7817 3.21329 19.7817 3.3127C19.7817 3.41211 19.8212 3.50746 19.8915 3.57778L20.423 4.1084C20.4579 4.14341 20.4993 4.17119 20.5449 4.19014C20.5905 4.2091 20.6394 4.21885 20.6888 4.21885C20.7382 4.21885 20.7871 4.2091 20.8327 4.19014C20.8783 4.17119 20.9198 4.14341 20.9546 4.1084L21.5199 3.5459C21.8059 3.26043 21.8326 2.79543 21.5598 2.49684Z" fill="#18D6BE"/>
                <path d="M18.7191 4.22031L10.2572 12.6672C10.2059 12.7183 10.1686 12.7817 10.149 12.8514L9.75756 14.0172C9.74818 14.0488 9.74752 14.0824 9.75564 14.1144C9.76375 14.1463 9.78035 14.1755 9.80368 14.1989C9.82701 14.2222 9.85621 14.2388 9.88818 14.2469C9.92016 14.255 9.95374 14.2544 9.98537 14.245L11.1502 13.8536C11.2199 13.8339 11.2833 13.7966 11.3344 13.7453L19.7813 5.2825C19.8594 5.20352 19.9033 5.09689 19.9033 4.98578C19.9033 4.87467 19.8594 4.76805 19.7813 4.68906L19.3149 4.22031C19.2358 4.14145 19.1287 4.09717 19.017 4.09717C18.9053 4.09717 18.7982 4.14145 18.7191 4.22031Z" fill="#18D6BE"/>
              </svg>
              <svg v-if="['back','temp'].includes(item.status)" @click="deleteProjectFn(item)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.25 5.25049L6.1875 20.2505C6.23203 21.1172 6.8625 21.7505 7.6875 21.7505H16.3125C17.1408 21.7505 17.7595 21.1172 17.8125 20.2505L18.75 5.25049" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.75 5.25049H20.25" stroke="#18D6BE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M9 5.25025V3.37525C8.99957 3.22739 9.02838 3.0809 9.08476 2.94422C9.14114 2.80753 9.22399 2.68334 9.32854 2.57879C9.4331 2.47424 9.55729 2.39139 9.69397 2.335C9.83066 2.27862 9.97715 2.24982 10.125 2.25025H13.875C14.0229 2.24982 14.1693 2.27862 14.306 2.335C14.4427 2.39139 14.5669 2.47424 14.6715 2.57879C14.776 2.68334 14.8589 2.80753 14.9152 2.94422C14.9716 3.0809 15.0004 3.22739 15 3.37525V5.25025" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 8.25073V18.7507" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.625 8.25073L9 18.7507" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.375 8.25073L15 18.7507" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="bottom-con">
            <div class="top-title-box">
              <!-- <img :src="item.projectIcon" alt="img"> -->
              <span @click="viewTask(item)">{{item.taskTheme}}</span>
              <div>{{item.taskType}}</div>
            </div>
            <div class="project-desc" v-if="item.project">
              <img :src="item.project.logo" alt="img">
              <span>{{item.project.entryName}}</span>
            </div>
            <div class="bottom-desc">
              <div class="desc ellipsis3" style="width: 100%;">{{item.taskDetails}}</div>
              <!-- <div class="time">{{item.createTime}}</div> -->
            </div>
            <div class="line-bounty">
              <div class="line"></div>
            </div>
            <div class="task-num">
              <div class="red-color" @click="changeTask('',item)">
                <div>{{item.countAll}}</div>
                <div>{{$t('Task.list.countAll')}}</div>
              </div>
              <div class="blue-color" @click="changeTask('tobechecked',item)">
                <!-- {{$t('Task.list.countTobechecked')}}: {{item.countTobechecked}} -->
                <div>{{item.countTobechecked}}</div>
                <div>{{$t('Task.list.countTobechecked')}}</div>
              </div>
              <div class="yellow-color" @click="changeTask('checked',item)">
                <!-- {{$t('Task.list.countChecked')}}: {{item.countChecked}} -->
                <div>{{item.countChecked}}</div>
                <div>{{$t('Task.list.countChecked')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!taskList.length" style="color: #bbb" class="no-data">{{$t('HotTask.NoData')}}</div>
        <div style="text-align: right;">
          <div v-if="showLoadMore2" class="load-more" @click="getMyTaskList">Load More</div>
        </div>
      </div>
      <div v-else>
        <bounty-schema-list :taskPlanStatus='taskPlanStatus' :DATA="planData" @goBack="backTask"></bounty-schema-list>
      </div>
    </div>
    <div v-else-if="currNum === 2" class="proposal-list-box">
      <div class="proposal-list" v-for="(item,index) in proposalList" :key="index">
        <div class="proposal-item">
          <div class="pi-left">
            <div v-if="item.status === 'temp'" class="status-box status1">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="white"/>
              </svg>
              <span>temp</span>
            </div>
            <div v-else-if="item.status === 'doing'" class="status-box status4">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="white"/>
              </svg>
              <span>doing</span>
            </div>
            <div v-else-if="item.status === 'tobechecked'" class="status-box status5">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="white"/>
              </svg>
              <span>tobechecked</span>
            </div>
            <div v-else-if="item.status === 'checked'" class="status-box status2">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="white"/>
              </svg>
              <span>checked</span>
            </div>
            <div v-else-if="item.status === 'unchecked'" class="status-box status3">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="white"/>
              </svg>
              <span>unchecked</span>
            </div>
            <div v-else-if="item.status === 'payed'" class="status-box status6">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="white"/>
              </svg>
              <span>payed</span>
            </div>
            <div v-else-if="item.status === 'close'" class="status-box status7">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="white"/>
              </svg>
              <span>close</span>
            </div>
          </div>
          <div v-if="item.completionDate" class="completion-date">{{$t('Proposal.CompletionDate')}} {{item.completionDate}}</div>
          <svg v-if="['temp','doing'].includes(item.status)" @click="editProposal(item)" class="pi-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 10.501V19.126C18 19.3722 17.9515 19.616 17.8573 19.8435C17.763 20.071 17.6249 20.2777 17.4508 20.4518C17.2767 20.6259 17.07 20.764 16.8425 20.8582C16.615 20.9525 16.3712 21.001 16.125 21.001H4.875C4.37772 21.001 3.90081 20.8034 3.54917 20.4518C3.19754 20.1002 3 19.6232 3 19.126V7.87598C3 7.37869 3.19754 6.90178 3.54917 6.55015C3.90081 6.19852 4.37772 6.00098 4.875 6.00098H12.7256" stroke="#18D6BE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21.5603 2.49684C21.4918 2.42158 21.4087 2.36098 21.3161 2.31872C21.2236 2.27646 21.1234 2.2534 21.0217 2.25095C20.9199 2.2485 20.8187 2.2667 20.7242 2.30445C20.6297 2.3422 20.5439 2.39872 20.4718 2.47059L19.892 3.04762C19.8217 3.11794 19.7822 3.21329 19.7822 3.3127C19.7822 3.41211 19.8217 3.50746 19.892 3.57778L20.4235 4.1084C20.4584 4.14341 20.4998 4.17119 20.5454 4.19014C20.591 4.2091 20.6399 4.21885 20.6893 4.21885C20.7387 4.21885 20.7876 4.2091 20.8332 4.19014C20.8788 4.17119 20.9203 4.14341 20.9551 4.1084L21.5204 3.5459C21.8063 3.26043 21.8331 2.79543 21.5603 2.49684Z" fill="#18D6BE"/>
            <path d="M18.7191 4.22031L10.2572 12.6672C10.2059 12.7183 10.1686 12.7817 10.149 12.8514L9.75756 14.0172C9.74818 14.0488 9.74752 14.0824 9.75564 14.1144C9.76375 14.1463 9.78035 14.1755 9.80368 14.1989C9.82701 14.2222 9.85621 14.2388 9.88818 14.2469C9.92016 14.255 9.95374 14.2544 9.98537 14.245L11.1502 13.8536C11.2199 13.8339 11.2833 13.7966 11.3344 13.7453L19.7813 5.2825C19.8594 5.20352 19.9033 5.09689 19.9033 4.98578C19.9033 4.87467 19.8594 4.76805 19.7813 4.68906L19.3149 4.22031C19.2358 4.14145 19.1287 4.09717 19.017 4.09717C18.9053 4.09717 18.7982 4.14145 18.7191 4.22031Z" fill="#18D6BE"/>
          </svg>
        </div>
        <div class="proposal-con">
          <div class="task-name">{{item.taskName}}</div>
          <div class="proposal-desc">{{item.proposalDesc}}</div>
          <div class="proposal-desc ellipsis" v-if="item.comments" :title="item.comments">{{$t('planDialog.RejectReason')}}: {{item.comments}}</div>
          <div class="bottom-box">
            <div class="bt-left-box">
              <!-- <svg v-if="item.newWork" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.1285 9.00018V15.7291C10.1363 16.2222 10.3376 16.6924 10.689 17.0383C11.0405 17.3843 11.5139 17.5782 12.007 17.5782C12.5001 17.5782 12.9735 17.3843 13.3249 17.0383C13.6764 16.6924 13.8777 16.2222 13.8855 15.7291L13.8916 6.8908C13.8967 6.46936 13.8181 6.0511 13.6604 5.66026C13.5026 5.26942 13.2689 4.91378 12.9727 4.61396C12.6765 4.31413 12.3237 4.07608 11.9348 3.91361C11.5459 3.75114 11.1286 3.66748 10.7071 3.66748C10.2857 3.66748 9.8684 3.75114 9.4795 3.91361C9.09061 4.07608 8.73783 4.31413 8.44161 4.61396C8.1454 4.91378 7.91165 5.26942 7.75391 5.66026C7.59617 6.0511 7.51758 6.46936 7.5227 6.8908V15.7886C7.53971 16.9647 8.01884 18.0868 8.85651 18.9124C9.69417 19.738 10.8231 20.2009 11.9993 20.2009C13.1754 20.2009 14.3043 19.738 15.142 18.9124C15.9797 18.0868 16.4588 16.9647 16.4758 15.7886V7.47393" stroke="#18D6BE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
              </svg>
              <div class="newwork" v-if="item.newWork">
                <a :href="item.newWork" :download="item.newWork" target="_blank">
                  {{item.newWork.substring(item.newWork.lastIndexOf('/')+1 ,item.newWork.length)}}
                </a>
                <a :href="'http://view.officeapps.live.com/op/view.aspx?src='+ item.newWork" target="_blank" class="view-btn" v-if="item.newWork && (item.newWork.includes('.doc') || item.newWork.includes('.docx'))">{{$t('My.view')}}</a>
              </div> -->
              <span v-if="item.dateOfProposal">{{$t('Proposal.dateOfProposal')}}: {{item.dateOfProposal}}</span>
            </div>
            <div class="bt-right-box">
              <!-- <img :src="item.headPotrit" alt="img"> -->
              <span>{{item.address}}</span>
            </div>
          </div>
          <div class="bottom-box">
            <div class="bt-left-box">
              <svg v-if="item.newWork" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.1285 9.00018V15.7291C10.1363 16.2222 10.3376 16.6924 10.689 17.0383C11.0405 17.3843 11.5139 17.5782 12.007 17.5782C12.5001 17.5782 12.9735 17.3843 13.3249 17.0383C13.6764 16.6924 13.8777 16.2222 13.8855 15.7291L13.8916 6.8908C13.8967 6.46936 13.8181 6.0511 13.6604 5.66026C13.5026 5.26942 13.2689 4.91378 12.9727 4.61396C12.6765 4.31413 12.3237 4.07608 11.9348 3.91361C11.5459 3.75114 11.1286 3.66748 10.7071 3.66748C10.2857 3.66748 9.8684 3.75114 9.4795 3.91361C9.09061 4.07608 8.73783 4.31413 8.44161 4.61396C8.1454 4.91378 7.91165 5.26942 7.75391 5.66026C7.59617 6.0511 7.51758 6.46936 7.5227 6.8908V15.7886C7.53971 16.9647 8.01884 18.0868 8.85651 18.9124C9.69417 19.738 10.8231 20.2009 11.9993 20.2009C13.1754 20.2009 14.3043 19.738 15.142 18.9124C15.9797 18.0868 16.4588 16.9647 16.4758 15.7886V7.47393" stroke="#18D6BE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
              </svg>
              <div class="newwork" v-if="item.newWork">
                <!-- {{item.newWork}} -->
                <a :href="item.newWork" :download="item.newWork" target="_blank">
                  {{item.newWork.substring(item.newWork.lastIndexOf('/')+1 ,item.newWork.length)}}
                </a>
                <a :href="'http://view.officeapps.live.com/op/view.aspx?src='+ item.newWork" target="_blank" class="view-btn" v-if="item.newWork && (item.newWork.includes('.doc') || item.newWork.includes('.docx'))">{{$t('My.view')}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!proposalList.length" style="color: #bbb" class="no-data">{{$t('HotTask.NoData')}}</div>
      <div style="text-align: right;">
        <div v-if="showLoadMore3" class="load-more" @click="getProposalList">Load More</div>
      </div>
    </div>
    <bounty-tip v-if="showTip" :content="deleteTip" :cancelBtn="$t('Project.Cancel')" :sureBtn="$t('Project.Yes')" @sure="sure" @close="close"></bounty-tip>
    <bounty-schema-tip v-if="showSchemaTip" :isEdit="true" :DATA="proposalData" :cancelBtn="'Cancel'" :sureBtn="'Save'" @sure="submitSchema" @sureCheck="sureCheck" @sureTodo="sureTodo" @close="closeSchema"></bounty-schema-tip>
  </div>
</template>

<script>
import { eventBus } from '@/plugin/eventBus/index.js'
import { submitPlanToCheck, submitPlanToDoing, getMyProjectList, removeProject, selectMyPartakePlan, updatePlan, selectMyPostTask, removeMyTask } from '@/api/bounty.js'
export default {
  name: 'myList',
  data () {
    return {
      showLoadMore1: false,
      showLoadMore2: false,
      showLoadMore3: false,
      count1: 0,
      count2: 0,
      count3: 0,
      planData: {},
      taskPlanStatus: '',
      taskListFather: true,
      proposalData: {},
      showSchemaTip: false,
      showTip: false, // 删除项目提示
      deleteProject: '', // 删除项目内容
      deleteTip: '', // 删除提示
      currNum: 0,
      tableLoading: false,
      table_data_current: [{
        MissionName: '1',
        ReleaseTime: '2',
        TheNumberOfparticipants: '3',
        id: '12'
      }, {
        MissionName: '1',
        ReleaseTime: '2',
        TheNumberOfparticipants: '3',
        id: '12'
      }],
      projectList: [
      //   {
      //   id: '1',
      //   projectIcon: 'http://49.232.5.191:8900/jeeStudio/gtoa/a/system/sysFile/fileDownload?fileId=9680fd0ddbe74020bc775226ce5551a1',
      //   projectName: 'PoolGo',
      //   projectDesc: 'poolgo.finance/#/',
      //   projectType: 'DeFi',
      //   createTime: '2021/09/01'
      // }
      ],
      taskList: [],
      projectData: {},
      proposalList: [
        // {
        //   status: 1,
        //   completionDate: '2021/09/10',
        //   taskName: 'Integrate Conflux in Mask',
        //   proposalDesc: 'Conflux Network is an open network built to drive the next generation of global commerce by unlocking the decentralized applications and digital assets of tomorrow. Conflux enables the secure and interoperable flow of assets and data across protocols & applications to create an internet of value for all.',
        //   newWork: 'Conflux Network',
        //   dateOfProposal: '2021/09/10',
        //   headPotrit: 'http://49.232.5.191:8900/jeeStudio/gtoa/a/system/sysFile/fileDownload?fileId=9680fd0ddbe74020bc775226ce5551a1',
        //   address: '0x18cd...75b0'
        // }
      ]
    }
  },
  mounted () {
    this.getProjectList()
  },
  computed: {
    tableListName: function () {
      return [this.$t('MyList.MyProject'), this.$t('MyList.publishedTasks'), this.$t('MyList.submittedProposal')]
      // this.$t('MyList.receivedScheme'),
    }
  },
  methods: {
    /**
     * @description: 取回
     * @param {*} data
     * @return {*}
     */
    async getBack (data) {
      // console.log(data.id)
      try {
        // 打开钱包
        const accounts = await conflux.request({ method: 'cfx_requestAccounts' }) // 打开钱包
        if (accounts[0] !== sessionStorage.getItem('walletAddress')) {
          this.$message({
            type: 'warning',
            offset: 120,
            message: this.$t('allTip.tip27')
          })
          eventBus.$emit('openWallet')
          this.$router.push({ name: 'Index' })
          return
        }
        const taskStatus = await this.$root.contract.withdrawFromClosedTask(data.id).sendTransaction({ from: sessionStorage.getItem('walletAddress'), gas: 140000, gasPrice: 10001 }).executed()
        eventBus.$emit('refreshTime')
        // const taskStatus = await this.$root.contract.withdrawFromClosedTask(data.id).sendTransaction({ from: sessionStorage.getItem('walletAddress') }).executed()
        const res = {
          state: true,
          data: taskStatus.transactionHash
        }
        this.$message({
          type: 'success',
          offset: 120,
          message: this.$t('allTip.tip22')
        })
        console.log('res', res)
      } catch (error) {
        // this.$message({
        //   type: 'error',
        //   offset: 120,
        //   message: error
        // })
      }
    },
    /**
     * @description: 返回我的页面
     * @param {*}
     * @return {*}
     */
    backTask () {
      this.planData = {}
      this.taskPlanStatus = ''
      this.taskListFather = true
      this.count2 = 0
      this.getMyTaskList()
    },
    /**
     * @description: 修改任务
     * @param {*} data
     * @return {*}
     */
    changeTask (data, obj) {
      // console.log(obj)
      this.planData = obj
      this.taskPlanStatus = data
      this.taskListFather = false
    },
    /**
     * @description: 提交方案
     * @param {*}
     * @return {*}
     */
    submitSchema (data) {
      updatePlan(data).then(res => {
        if (!res.code) {
          this.closeSchema()
          this.$message({
            type: 'success',
            offset: 120,
            message: 'success'
          })
          this.count3 = 0
          this.getProposalList()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 确定todo
     * @param {*} data
     * @return {*}
     */
    sureTodo (data) {
      submitPlanToDoing(data).then(res => {
        if (!res.code) {
          this.closeSchema()
          this.$message({
            type: 'success',
            offset: 120,
            message: 'success'
          })
          this.count3 = 0
          this.getProposalList()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 确定check
     * @param {*}
     * @return {*}
     */
    sureCheck (data) {
      submitPlanToCheck(data).then(res => {
        if (!res.code) {
          this.closeSchema()
          this.$message({
            type: 'success',
            offset: 120,
            message: 'success'
          })
          this.count3 = 0
          this.getProposalList()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 关闭方案
     * @param {*}
     * @return {*}
     */
    closeSchema () {
      this.showSchemaTip = false
    },
    /**
     * @description: 编辑方案数据
     * @param {*} data
     * @return {*}
     */
    editProposal (data) {
      // console.log(data)
      this.proposalData = {
        id: data.id,
        status: data.status,
        taskId: data.taskId,
        programmeDetails: data.programmeDetails,
        completion: data.completion,
        completeAttachment: data.completeAttachment
      }
      this.showSchemaTip = true
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    close () {
      this.deleteProject = {}
      this.showTip = false
      this.deleteTip = ''
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    sure () {
      if (this.currNum === 0) { // 删除项目
        removeProject({
          id: this.deleteProject.id
        }).then(res => {
          if (!res.code) {
            this.$message({
              type: 'success',
              offset: 120,
              message: 'success'
            })
            this.showTip = false
            this.getProjectList()
          }
        }).catch(err => {
          console.log(err)
        })
      } else if (this.currNum === 1) { // 删除任务
        removeMyTask({
          id: this.deleteProject.id
        }).then(res => {
          if (!res.code) {
            this.$message({
              type: 'success',
              offset: 120,
              message: 'success'
            })
            this.showTip = false
            this.getMyTaskList()
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    /**
     * @description: 查看项目详情
     * @param {*} data
     * @return {*}
     */
    viewProject (data) {
      this.$emit('createProject', data, false, true) // 第三个参数代表查看
    },
    /**
     * @description: 查看task详情
     * @param {*} data
     * @return {*}
     */
    viewTask (data) {
      this.$emit('createTask', data, false, true) // 第三个参数代表查看
    },
    /**
     * @description: 编辑项目
     * @param {*} data
     * @return {*}
     */
    editProject (data) {
      this.$emit('createProject', data)
    },
    /**
     * @description: 编辑任务
     * @param {*} data
     * @return {*}
     */
    editTask (data) {
      this.$emit('createTask', data)
    },
    /**
     * @description: 删除项目
     * @param {*} data
     * @return {*}
     */
    deleteProjectFn (data) {
      this.deleteProject = data
      if (this.currNum === 0) { // 移除项目
        this.deleteTip = this.$t('Project.Remove') + data.projectName + '?'
      } else if (this.currNum === 1) { // 移除任务
        this.deleteTip = this.$t('Project.Remove') + data.taskTheme + '?'
      }
      this.showTip = true
    },
    /**
     * @description: 创建项目
     * @param {*}
     * @return {*}
     */
    newProject () {
      if (Number(sessionStorage.getItem('pandaStatus')) !== 1) { // 无pandaid
        this.$message({
          type: 'warning',
          offset: 120,
          message: this.$t('Skills.skilPandaId.tip2')
        })
      } else {
        this.$emit('createProject')
      }
    },
    /**
     * @description: 获取方案列表
     * @param {*}
     * @return {*}
     */
    getProposalList () {
      selectMyPartakePlan({
        count: this.count3,
        pageSize: 10
      }).then(res => {
        if (!res.code) {
          // console.log(res.data)
          // {
          //   status: 1,
          //   completionDate: '2021/09/10',
          //   taskName: 'Integrate Conflux in Mask',
          //   proposalDesc: 'Conflux Network is an open network built to drive the next generation of global commerce by unlocking the decentralized applications and digital assets of tomorrow. Conflux enables the secure and interoperable flow of assets and data across protocols & applications to create an internet of value for all.',
          //   newWork: 'Conflux Network',
          //   dateOfProposal: '2021/09/10',
          //   headPotrit: 'http://49.232.5.191:8900/jeeStudio/gtoa/a/system/sysFile/fileDownload?fileId=9680fd0ddbe74020bc775226ce5551a1',
          //   address: '0x18cd...75b0'
          // },
          if (res.data && res.data.planList.length) {
            this.count3 = this.count3 + res.data.planList.length
            if (res.data.planList.length === 10) {
              this.showLoadMore3 = true
            } else {
              this.showLoadMore3 = false
            }
            this.proposalList = res.data.planList.map(item => {
              return {
                comments: item.comments,
                completeAttachment: item.completeAttachment,
                completion: item.completion,
                programmeDetails: item.programmeDetails,
                taskId: item.task.id,
                status: item.status,
                id: item.id,
                completionDate: item.completionDate,
                taskName: item.task.taskTheme,
                proposalDesc: item.task.taskDetails,
                newWork: item.completeAttachment,
                dateOfProposal: item.dateIntroduced,
                headPotrit: 'http://bountyv2.oss-cn-hongkong.aliyuncs.com/bounty2/image/1450089152249991168.png',
                address: item.userId ? item.userId.substring(item.userId.length - 13, item.userId.length - 7) + '...' + item.userId.substring(item.userId.length - 4, item.userId.length) : ''
              }
            })
          } else {
            this.proposalList = []
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 获取projectList
     * @param {*}
     * @return {*}
     */
    getProjectList () {
      if (sessionStorage.getItem('walletAddress')) {
        getMyProjectList().then(res => {
          if (!res.code) {
          // this.projectList = res.data.projectList || []
          // const data1 = [{
          //   id: '1444112261378609200',
          //   entryName: 'projectname',
          //   projectType: 'nft',
          //   projectWebsite: 'url',
          //   logo: 'http://bountyv2.oss-cn-hongkong.aliyuncs.com/bounty2/image%5C1444117279213228032.png',
          //   remarks: '123'
          // }]
            this.projectList = res.data.projectList.map(item => {
              return {
                id: item.id,
                projectIcon: item.logo,
                projectName: item.entryName,
                projectDesc: item.remarks,
                locked: item.locked,
                projectType: item.projectType,
                ProjectURL: item.projectWebsite,
                createTime: item.creationTime ? item.creationTime : ''
              }
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    /**
     * @description: 获取任务列表
     * @param {*}
     * @return {*}
     */
    getMyTaskList () {
      selectMyPostTask({
        count: this.count2,
        pageSize: 10,
        search: '',
        status: ''
      }).then(res => {
        if (!res.code) {
          if (res.data && res.data.taskList.length) {
            this.count2 = this.count2 + res.data.taskList.length
            if (res.data.taskList.length === 10) {
              this.showLoadMore2 = true
            } else {
              this.showLoadMore2 = false
            }
            this.taskList = res.data.taskList.map(item => {
              return {
                id: item.id,
                status: item.status,
                projectIcon: item.logo,
                taskTheme: item.taskTheme,
                taskDetails: item.taskDetails,
                taskType: item.taskType,
                project: item.project,
                ProjectURL: item.projectWebsite,
                createTime: item.creationTime ? item.creationTime : '',
                countAll: item.countAll,
                countTobechecked: item.countTobechecked,
                countChecked: item.countChecked,
                totalAwards: item.totalAwards
              }
            })
          } else {
            this.taskList = []
          }
          // this.taskList = res.data.taskList.map(item => {
          //   return {
          //     id: item.id,
          //     status: item.status,
          //     projectIcon: item.logo,
          //     taskTheme: item.taskTheme,
          //     taskDetails: item.taskDetails,
          //     taskType: item.taskType,
          //     ProjectURL: item.projectWebsite,
          //     createTime: item.creationTime ? item.creationTime : '',
          //     countAll: item.countAll,
          //     countTobechecked: item.countTobechecked,
          //     countChecked: item.countChecked
          //   }
          // })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 修改currNum
     * @param {Number} index
     * @return {*}
     */
    changeCurrNum (index) {
      this.count1 = 0
      this.count2 = 0
      this.count3 = 0
      this.currNum = index
      if (index === 0) {
        this.getProjectList()
      } else if (index === 1) {
        this.getMyTaskList()
      } else if (index === 2) {
        this.getProposalList()
      }
    },
    /**
     * @description: 编辑数据
     * @param {*} data
     * @return {*}
     */
    editData (data) {
      console.log('编辑数据')
    },
    /**
     * @description: 删除数据
     * @param {*} data
     * @return {*}
     */
    deleteData (data) {
      console.log('删除数据')
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    createTask () {
      console.log('创建项目')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/gloabal.scss';
.task-list-box{
  .task-list{
    .task-num{
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 16px;
      div{
        font-family: $fontFamilyCircularStd;
        font-style: normal;
        font-weight: normal;
        text-align: center;
        &:first-of-type{
          font-size: 26px;
          line-height: 33px;
          margin-bottom: 4px;
          color: #18D6BE;
        }
        &:last-of-type{
          font-size: 22px;
          line-height: 28px;
          color: #BBBBBB;
        }
      }
    }
    .red-color{
      // font-family: $fontFamilyCircularStd;
      color: red;
    }
    .blue-color{
      // font-family: $fontFamilyCircularStd;
      color: #18D6BE;
    }
    .yellow-color{
      // font-family: $fontFamilyCircularStd;
      color: #F1A003;
    }
    &:last-of-type{
      margin-bottom: 0;
    }
  }
}
.my-list{
  .create-box{
    display: flex;
    height: 32px;
    float: left;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    svg{
      margin-right: 8px;
    }
    margin-bottom: 40px;
  }
  .list-item{
    margin-bottom: 30px;
    &:last-of-type{
      margin-bottom: 0;
    }
  }
  .tb-create{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 42px;
    margin-bottom: 32px;
  }
  .create-project{
    cursor: pointer;
    margin-top: 42px;
    width: 230px;
    // padding: ;
    display: flex;
    align-items: center;
    height: 72px;
    // width: 170px;
    padding-right: 18px;
    text-align: center;
    padding-left: 18px;
    background: linear-gradient(93.58deg, #A737FF 0%, #18D6BE 100%);
    border-radius: 8px;
    font-family: $fontFamilyCircularStd;
    font-style: normal;
    font-weight: bold;
    font-size: 26px;
    svg{
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }
  }
  .table-list{
    // float: left;
    display: flex;
    width: 100%;
    background: #35353D;
    justify-content: space-around;
    align-items: center;
    border-radius: 12px;
    height: 72px;
    .tb-item{
      cursor: pointer;
      font-family: $fontFamilyCircularStd;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      padding: 2rem 0em;
      width: 33%;
      text-align: center;
      // width: 33.3%;
      // flex: 1;
      // line-height: 16px;
      // padding: 28px 24px;
    }
    .tb-item.curr{
      color: #18D6BE;
      background: #4C4C55;
      border-radius: 12px;
      font-family: $fontFamilyCircularStd;
      font-style: normal;
      font-weight: bold;
    }
  }
  .projectType{
    font-family: $fontFamilyCircularStd;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    padding: 0 16px;
    height: 36px;
    line-height: 36px;
    background: #4C4C55;
    border-radius: 18px;
  }
  .top-control{
    padding-left: 24px;
    height: 68px;
    display: flex;
    justify-content: space-between;
    border-radius: 12px 12px 0 0;
    background: #2B2A31;
    align-items: center;
    // padding-right: 24px;
    .svg-box{
      svg{
        width: 42px;
        height: 42px;
      }
    }
    svg{
      margin-right: 33px;
      cursor: pointer;
    }
  }
  .bottom-con{
    background: #35353D;
    padding: 27px 24px;
    border-radius: 0 0 12px 12px;
    .top-title-box{
      display: flex;
      align-items: center;
      img{
        width: 36px;
        height: 36px;
        border-radius: 100%;
        margin-right: 12px;
      }
      span{
        font-family: $fontFamilyCircularStd;
        font-style: normal;
        font-weight: bold;
        font-size: 34px;
        margin-right: 12px;
        cursor: pointer;
      }
      div{
        font-family: $fontFamilyCircularStd;
        font-style: normal;
        font-weight: normal;
        height: 36px;
        line-height: 36px;
        font-size: 22px;
        background: #4C4C55;
        border-radius: 18px;
        padding: 0 16px;
      }
    }
  }
  .line-bounty{
    height: 1px;
    margin-top: 24px;
    // margin-bottom: 16px;
    position: relative;
    .line:before{
      content: " ";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      border-top: 1px solid #4C4C55;
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
  .project-desc{
    display: flex;
    align-items: center;
    margin-top: 12px;
    img{
      width: 20px;
      height: 20px;
      margin-right: 8px;
      border-radius: 100%;
    }
    span{
      font-family: Circular Std;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      // line-height: 20px;
    }
  }
  .bottom-desc{
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .desc{
      font-family: $fontFamilyCircularStd;
      font-style: normal;
      font-weight: normal;
      font-size: 26px;
      line-height: 33px;
      color: #bbb;
      width: 54%;
    }
    .time{
      font-family: $fontFamilyCircularStd;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 30px;
      color: #bbb;
    }
  }
}
.status-box{
  display: flex;
  align-items: center;
  font-family: $fontFamilyCircularStd;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  height: 36px;
  padding: 0 16px;
  border-radius: 18px;
  // margin-right: 18px;
  svg{
    width: 12px;
    height: 12px;
    margin-right: 8px !important;
  }
}
// temp
.status1{
  background-color: #F1A003;
}
.status2{
  background: #5337FF;
}
.status3{
  background: #FF6262;
}
// going
.status4{
  background: #18D6BE;
}
// Upcoming
.status5{
  background: #A737FF;
}
// #finished payed
.status6{
  background: #BBBBBB;
}
// Close 1
.status7{
  background: #FF8744;
}
.proposal-item{
  padding: 16px 24px;
  background: #2B2A31;
  border-radius: 12px 12px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .pi-left{
    display: flex;
    align-items: center;
  }
  .completion-date{
    font-family: $fontFamilyCircularStd;
    font-style: normal;
    font-weight: normal;
    color: #BBBBBB;
    font-size: 24px;
    line-height: 24px;
    color: #bbb;
  }
  .pi-svg{
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
}
.proposal-con{
  padding: 24px;
  background: #35353D;
  border-radius: 0 0 12px 12px;
  .task-name{
    font-family: $fontFamilyCircularStd;
    font-style: normal;
    font-weight: bold;
    font-size: 34px;
    line-height: 34px;
    margin-bottom: 16px;
  }
  .proposal-desc{
    font-family: $fontFamilyCircularStd;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 33px;
    color: #bbb;
    margin-bottom: 24px;
  }
  .bottom-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .bt-left-box{
      display: flex;
      align-items: center;
      margin-top: 12px;
      svg{
        width: 32px;
        height: 32px;
      }
      .newwork{
        a{
          font-family: $fontFamilyCircularStd;
          font-style: normal;
          font-weight: normal;
          font-size: 26px;
          line-height: 33px;
          color:#18D6BE;
          margin-right: 21px;
        }
        .view-btn{
          margin-right: 21px;
        }
      }
      span{
        font-family: $fontFamilyCircularStd;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        color: #bbb;
      }
    }
    .bt-right-box{
      display: flex;
      align-items: center;
      img{
        width: 20px;
        height: 20px;
        border-radius: 100%;
        margin-right: 8px;
      }
      span{
        font-family: $fontFamilyCircularStd;
        font-style: normal;
        font-weight: normal;
        font-size: 26px;
      }
    }
  }
}
.proposal-list-box{
  .proposal-list{
    margin-bottom: 30px;
    &:last-of-type{
      margin-bottom: 0;
    }
  }
}

</style>
